import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

import Banner from '../../components/banner'
import Layout from '../../components/layouts/mainLayout'
import RosterCard from '../../components/roster-card'
import { roster21U } from '../../components/data'

//Images

const Rosters21U = () => {

    const data = useStaticQuery(graphql`
        query {
            File: allFile (filter: {sourceInstanceName:{eq: "roster"}}
            sort: {fields: relativePath}){
                edges {
                    node{
                        relativePath
                        ...FluidImageFragment

                    }
                }
            }
            BannerImg: file(relativePath: {eq:"mural.jpg"}){
                ...FluidImageFragment
            }
            TeamImg: file(relativePath: {eq:"19u.jpg"}){
                ...FluidImageFragment
            }
        }
    `)

    return (

        <Layout>
            <Banner 
                title="21U ROSTER" 
                img={data.BannerImg.childImageSharp.fluid}
                height="small"
            />
            <div className="team-photo">
                <Img fluid={data.TeamImg.childImageSharp.fluid} />
            </div>
            <div className="roster-list">
                {roster21U.map((player, index) => 
                    <>
                        <RosterCard 
                            img={data.File.edges[index].node.childImageSharp.fluid}
                            name={player.name}
                            number={player.number}
                            position={player.position}
                            team={player.team}
                            class={player.class}
                            shaded={player.shaded}
                        />
                        <div className="linebreak"></div>
                    </>
                )}
            </div>
        </Layout>
        
    )
}

export default Rosters21U
